"use client";

import { t } from "@/lib/localization";

export default function PaymentHeader() {
    return (
        <div>
            <h2 className="text-xl font-semibold">
                {t("payments.header.title.payment")}
            </h2>
        </div>
    );
}
